<template>
  <b-container fluid>
      <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('sales_center.demand_order') }} {{ $t("globalTrans.details") }}</h4>
        </template>
        <template v-slot:headerAction>
            <router-link to="demand-order-view" :class="'btn btn-primary text-light'"><i class="ri-file-text-line"></i>{{ $t('sales_center.demand_order') }} {{ $t('globalTrans.list') }}</router-link>
        </template>
        <template v-slot:body>
    <b-row v-if="loading">
      <b-col lg="4" class="ml-3">
        <span class="text-dark">
          {{ $t("sales_center.sales_center") }} : {{ getSalesCenterName(dataArray.sales_center_id) }}
        </span>
      </b-col>
      <b-col lg="3" class="text-center">
        <span class="text-dark" v-if="dataArray.demmand_type === 1">
          {{ $t("sales_center.demand_id") }} : {{ 'P - ' }} {{ dataArray.demand_id }}
        </span>
        <span v-else class="text-dark">
          {{ $t("sales_center.demand_id") }} : {{ 'W - ' }} {{ dataArray.demand_id }}
        </span>
      </b-col>
      <b-col lg="4" class="text-right">
        <span class="text-dark">
          {{ $t("sales_center.demand_date") }} : {{ dataArray.demand_date | dateFormat }}
        </span>
      </b-col>
      <div class="mt-4 col-lg-12 col-sm-12 col-md-12">
        <b-col class="m-0">
          <b-overlay>
            <table class="table table-bordered">
              <tr class="bg-light">
                <th width="100px">{{ $t("globalTrans.sl_no") }}</th>
                <th>{{ $t("production_store.pro_category") }}</th>
                <th>{{ $t("production_store.pro_name") }}</th>
                <th>{{ $t("production_store.pro_unit") }}</th>
                <th>{{ $t("sales_center.quantity") }}</th>
              </tr>
              <tr v-for="(item, index) in dataArray.details" :key="index">
                <td>{{ $n(index + 1) }}</td>
                <td>{{ getCategoryName(item.product_id) }}</td>
                <td>{{ productNameById(item.product_id) }}</td>
                <td>{{ unitNameById(item.unit_id) }}</td>
                <td>{{ $n(item.quantity) }}</td>
              </tr>
            </table>
          </b-overlay>
        </b-col>
        <b-row>
          <b-col lg="6" sm="12">
            <b-form-group class="row" label-cols-sm="12" label-for="comment">
              <template v-slot:label>
                {{ $t("production_store.comment_en") }}
              </template>
              <b-textarea
                rows="1"
                readonly
                id="comment"
                v-model="dataArray.comment"
              ></b-textarea>
            </b-form-group>
          </b-col>
          <b-col lg="6" sm="12">
            <b-form-group class="row" label-cols-sm="12" label-for="comment_bn">
              <template v-slot:label>
                {{ $t("production_store.comment_bn") }}
              </template>
              <b-textarea
                readonly
                id="comment_bn"
                v-model="dataArray.comment_bn"
              ></b-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-row>
        </template>
      </iq-card>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { demandOrderById } from '../../api/routes'

export default {
  props: ['id'],
  data () {
    return {
      dataArray: {
        sales_center_id: '',
        demand_id: '',
        demand_date: '',
        delivery_date: '',
        demmand_type: 1,
        comment: '',
        comment_bn: '',
        details: []
      },
      mat_id: 0,
      sl: 0,
      loading: false
    }
  },
  created () {
    if (this.$route.query.id) {
      this.mat_id = this.$route.query.id
      this.getDemandInfoData(this.$route.query.id)
    }
  },
  computed: {
    categoryList: function () {
      return this.productCommonObj.productCategoryList.filter(
        (item) => item.status === 1
      )
    },
    salesCenterList: function () {
      return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  methods: {
    cancel () {
      if (this.mat_id) {
        this.$router.push({
          path: '/production-service/sales-target/demand-order-view'
        })
      }
    },
    async getDemandInfoData (id) {
      const result = await RestApi.getData(
        productionServiceBaseUrl,
        demandOrderById + '/' + id
      )
      if (result.success) {
        this.dataArray.demand_id = result.data.demmand_id
        this.dataArray.demand_date = result.data.demmand_date
        this.dataArray.sales_center_id = result.data.sales_center_id
        this.dataArray.delivery_date = result.data.delivery_date
        this.dataArray.demmand_type = result.data.demmand_type
        this.dataArray.details = result.data.demand_details
        this.dataArray.comment = result.data.comment
        this.dataArray.comment_bn = result.data.comment_bn
        this.loading = true
      }
    },
    getCategoryName (Id) {
      const product = this.productCommonObj.productList.find(product => product.value === Id)
      if (typeof product !== 'undefined') {
        const Obj = this.productCommonObj.productCategoryList.find(el => el.value === product.category_id)
        return typeof Obj !== 'undefined' ? (this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn) : ''
      }
      return ''
    },
    productNameById (id) {
      const product = this.productCommonObj.productList.find(
        (product) => product.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return product.text_bn
      } else {
        return product.text_en
      }
    },
    unitNameById (id) {
      const unit = this.productCommonObj.productUnitList.find(
        (unit) => unit.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return unit.text_bn
      } else {
        return unit.text_en
      }
    },
    getSalesCenterName (id) {
      const salesCenter = this.salesCenterList.find(
        (salescenter) => salescenter.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return salesCenter.text_bn
      } else {
        return salesCenter.text_en
      }
    }
  }
}
</script>
